<template>
  <div>
    <div
      class="dropdown is-right"
      :class="{ 'is-active': isActive }"
      v-click-outside="close"
    >
      <div class="dropdown-trigger">
        <button
          class="button is-primary is-outlined is-pulled-right"
          :title="$t('Sort by') + ' ' + $t(activeSorter.text)"
          @click="toggle"
        >
          <span class="icon is-small">
            <i class="fa" :class="activeSorter.icon" />
          </span>
        </button>
      </div>
      <div class="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <a
            v-for="sorter in sorters"
            :key="sorter.sortBy"
            class="dropdown-item"
            :class="{ 'is-active': sorter === activeSorter }"
            @click="onClick(sorter)"
          >
            {{ $t(sorter.text) }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sort-button",
  props: ["sorters", "activeSorter"],
  data() {
    return {
      isActive: false
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
    },
    close() {
      this.isActive = false
    },
    onClick(sorter) {
      this.close()
      this.$emit("change", sorter)
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-menu {
  width: auto;
}
</style>
